export enum AutoTransform {
    UPPER_CASE = 'UPPER_CASE',
    LOWER_CASE = 'LOWER_CASE',
    COMPUTE = 'COMPUTE'
}
